import {
	Icon,
	IconBackpack,
	IconProps,
	IconSchool,
	IconWorld
} from '@tabler/icons-react';

import { Button, Card, Group, Space, Title, Text, useMantineTheme } from '@mantine/core';
import { useContext } from 'react';
import { SessionContext } from '@/context/SessionContext';

interface FilterData {
	filter: "all" | "my-videos" | "my-classroom";
	label: string;
	icon: React.ForwardRefExoticComponent<IconProps & React.RefAttributes<Icon>>;
}


interface VideoBrowserSidebarProps {
	currentFilter: string;
	setFilter: (filter: "all" | "my-videos" | "my-classroom") => void;
};

const VideoBrowserSidebar: React.FC<VideoBrowserSidebarProps> = ({ currentFilter, setFilter }) => {
	const theme = useMantineTheme();
	const session = useContext(SessionContext);
	if (!session) {
		throw new Error("VideoBrowserSidebar must be a child of SessionContext.");
	}

	const filterData: FilterData[] = [
		{ filter: 'all', label: 'All Videos', icon: IconWorld },
		{ filter: 'my-videos', label: 'My Videos', icon: IconBackpack }
	];

	if (session.user?.classroomId) {
		filterData.push({ filter: 'my-classroom', label: 'Videos From My Classroom', icon: IconSchool });
	}

	const filterButtons = filterData.map((item) => (
		<Button
			data-active={currentFilter === item.filter ? true : undefined}
			key={item.label}
			onClick={(event) => {
				event.preventDefault();
				setFilter(item.filter);
			}}
			w="100%"
			color={currentFilter === item.filter ? theme.colors.blue[1] : theme.colors.blue[6]}
			leftSection={
				<item.icon
					color={currentFilter === item.filter ? "black" : theme.colors.blue[0]}
					size={18}
				/>
			}
			justify='left'
		>
			<Text
				c={currentFilter === item.filter ? "black" : theme.colors.blue[0]}
				size='sm'
			>
				{item.label}
			</Text>
		</Button>
	));

	return (
		<Card
			h="100%"
			w="300px"
			bg={theme.colors.blue[8]}
		>
			<Title
				c={theme.colors.blue[1]}
			>
				Videos
			</Title>

			<Space h="lg" />

			<Group
				w="100%"
			>
				{filterButtons}
			</Group>
		</Card>
	);
}

export default VideoBrowserSidebar;